import React, { useContext, useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import "./navigation.css";
import logo from "../../assets/logo.png";
import { ClipLoader } from "react-spinners";
import { AuthContext } from "../../context/auth-context";
import Hamburger from "hamburger-react";
import settingsIcon from "../../assets/settings.png";
import { request } from "../../utils/axios-utils";

import logoutIcon from "../../assets/logout.png";
import backIcon from "../../assets/navigationIcons/back.png";
import editorIcon from "../../assets/navigationIcons/editor.png";
import orderIcon from "../../assets/navigationIcons/order.png";
import infoIcon from "../../assets/navigationIcons/info.png";
import languageIcon from "../../assets/navigationIcons/language.png";
import promotionIcon from "../../assets/navigationIcons/promotion.png";
import qrCodeIcon from "../../assets/navigationIcons/qr_code.png";
import billingIcon from "../../assets/navigationIcons/billing.png";

const Navigation = ({ children, isLoading }) => {
  const { slug } = useParams();
  const { logout } = useContext(AuthContext);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [menuName, setMenuName] = useState("");

  const links = [
    { path: `/${slug}/menu-editor`, name: "Menu Editor", icon: editorIcon },
    { path: `/${slug}/menu-order`, name: "Menu Order", icon: orderIcon },
    { path: `/${slug}/languages`, name: "Languages", icon: languageIcon },
    { path: `/${slug}/qr-code`, name: "QR Code", icon: qrCodeIcon },
    {
      path: `/${slug}/additional-info`,
      name: "Additional Info",
      icon: infoIcon,
    },
    { path: `/${slug}/promotions`, name: "Promotions", icon: promotionIcon },
    { path: `/${slug}/billing`, name: "Billing", icon: billingIcon },
  ];

  const isActive = (path) => {
    if (path.startsWith(`/${slug}/menu-editor`)) {
      return location.pathname.startsWith(`/${slug}/menu-editor`);
    }
    if (path.startsWith(`/${slug}/menu-order`)) {
      return location.pathname.startsWith(`/${slug}/menu-order`);
    } else {
      return location.pathname === path;
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading("data");

        const response = await request({
          url: "/member/get-nav-data",
          method: "POST",
          data: { slug },
        });

        setName(response.data.userName);
        setMenuName(response.data.menuName);
      } catch (error) {
      } finally {
        setLoading("");
      }
    };

    getData();
  }, []);

  return (
    <div className="page-container">
      <div className="header-container">
        <div className="header-container-bar-div">
          <Link to={"/"}>
            <img src={logo} className="header-logo-img" />
          </Link>

          <div className="header-text-div">
            <div className="header-help-div">Help</div>
            <Link to={"/settings"} className="header-settings-div">
              <img className="header-settings-img" src={settingsIcon} />
            </Link>
            <div className="header-name-div">
              {loading === "data" ? (
                <ClipLoader size={15} color="#fff" />
              ) : (
                <>
                  {name}
                  <div onClick={logout} className="logout-div">
                    <p>Log out</p>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="navigation-hamburger-icon">
            <Hamburger
              toggled={isOpen}
              toggle={() => {
                setIsOpen((prevState) => !prevState);
              }}
              duration={0.5}
              color="#ed6e12"
            />
          </div>
        </div>

        <div
          className={`navigation-mobile-container ${
            isOpen === true ? "navigation-mobile-container-opened" : ""
          }`}
        >
          <div className="navigation-menu-name-div">
            {loading === "data" ? (
              <ClipLoader size={16} color={"#fff"} />
            ) : (
              menuName
            )}
          </div>
          <Link
            to={"/"}
            className="navigation-mobile-link-bar text-decoration-none"
          >
            <img src={backIcon} className="header-mobile-link-img" />
            <p className="header-mobile-link-p">Go back to All Menus</p>
          </Link>
          <div className="navigation-line" />
          {links.map((link) => {
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`navigation-mobile-link-bar text-decoration-none ${
                  isActive(link.path) ? "navigation-mobile-link-bar-active" : ""
                }`}
              >
                <img src={link.icon} className="header-mobile-link-img" />
                <p className="header-mobile-link-p">{link.name}</p>
              </Link>
            );
          })}
          <div onClick={logout} className="navigation-mobile-link-bar">
            <img src={logoutIcon} className="header-mobile-link-img" />
            <p className="header-mobile-link-p">Logout</p>
          </div>
        </div>
      </div>

      <div className="page-helper-div">
        <div className="navigation-div">
          <div className="navigation-menu-name-div">
            {loading === "data" ? (
              <ClipLoader size={16} color={"#fff"} />
            ) : (
              menuName
            )}
          </div>
          <Link to={"/"} className="navigation-bar-div">
            <img className="navigation-bar-img" src={backIcon} />
            <p className="navigation-bar-p">Go back to All Menus</p>
          </Link>
          <div className="navigation-line" />

          {links.map((link) => {
            return (
              <Link
                key={link.name}
                to={link.path}
                className={`navigation-bar-div ${
                  isActive(link.path) ? "navigation-bar-div-active" : ""
                }`}
              >
                <img className="navigation-bar-img" src={link.icon} />
                <p className="navigation-bar-p">{link.name}</p>
              </Link>
            );
          })}
        </div>

        <div className="page-content-div">
          {isLoading ? (
            <div className="page-content-loader-div">
              <ClipLoader size={100} color={"#ed6e12"} />
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
